import type { ReactNode } from "react";
import { DrawingPinIcon } from "@radix-ui/react-icons";
import clsx from "clsx";
import { DisplayText } from "../DisplayText";

interface GuideSectionProps {
  title: string;
  children: ReactNode;
  id?: string;
}

export function GuideSection({ title, children, id }: GuideSectionProps) {
  return (
    <section id={id}>
      <div className={clsx("flex", "items-center", "mb-4")}>
        <span className={clsx("block", "text-blue-600", "mr-2")}>
          <DrawingPinIcon aria-hidden="true" width={20} height={20} />
        </span>
        <DisplayText element="h2" size="large">
          {title}
        </DisplayText>
      </div>
      <div className={clsx("flex", "flex-col", "flex-grow", "pl-2")}>{children}</div>
    </section>
  );
}
